import "./css/office.css";
import quoteM from "../../images/quoteIcon.jpg";
import LFilter from "../../images/filter.png";
import CManager from "../../images/1478890.png";
import Expen from "../../images/8910710.png";

import ExpApp from "../../images/travelApp.png";
import TickApp from "../../images/ticket.png";
import SaleApp from "../../images/saleApprove.png";

import LManager from "../../images/1478890.png";
import usrs from "../../images/usrs.png";
import reporting from "../../images/report-vector-icon-png_295013.jpg";
import products from "../../images/productManager.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import InvalidAccess from "./InvalidAccess";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Dashboard() {
  const Navigate = useNavigate();
  const currentPage = useLocation().pathname;
  useLocation().pathname = "customers";
  let username = localStorage.getItem("user");
  let busi = localStorage.getItem("business_id");
  let ryts = localStorage.getItem("user_rights");
  if (
    localStorage.getItem("user") == 20000 ||
    localStorage.getItem("user") == ""
  ) {
    return <InvalidAccess />;
  } else if (username === null) {
    return Navigate("../");
  } else {
    return (
      <div>
        <div id="welcome">
          Welcome Back <br />
          <strong>
            {localStorage.getItem("user_name")}{" "}
            <small>({localStorage.getItem("business")})</small>
          </strong>
        </div>
        <div id="logout">
          <small>
            <Link to="../logout"> Logout </Link>
          </small>
        </div>{" "}
        <div id="logout">
          <small>{/* <Link to="../profile"> Update profile </Link> */}</small>
        </div>
        <div className="officeNav">
          <Link className="nav-link" to="../Ticket" ><img src={TickApp} /> <br />Task</Link>
        {
          (ryts == 3 || ryts == 1) ? 
          <>
          <Link className="nav-link" to="../SaleApp" ><img src={SaleApp} /> <br />Approve Sales</Link>
          <Link className="nav-link" to="../LocApp" ><img src={ExpApp} /> <br />Approve Visits(s)</Link></> :
          ""
        }
          {ryts != 3 ? <>
          {/* <Link className="Lead Manager">
            <img src={CManager} /> <br />
            Lead Manager
          </Link>*/} 
          <Link className="nav-link" to="../expen">
            <img src={Expen} /> <br />
            Expense Manager
          </Link>
          <Link className="nav-link" to="../lead" >
            <img src={LFilter} /> <br />
            Lead Manager
          </Link>
          <Link className="nav-link" to="../customers" >
            <img src={CManager} /> <br />
            Add/Edit Customer(s)
          </Link>
          <Link className="nav-link" to="../quotes" >
            <img src={quoteM} /><br />
            Quote Manager
          </Link></>
           : "" }
            
          <Link
            className={
              currentPage === "/reports" ? "nav-link active" : "nav-link"
            }
            to="../reports"
          >
            <img src={reporting} />
            <br />
            Sale Reports
          </Link>
          {ryts == 1 ? (
            <><Link className="nav-link" to="../products" >
              <img src={products} /><br />
              Manage Products
            </Link>
            {/* <Link className="nav-link" to="../users" >
              <img src={usrs} /><br />
              Manage Users
            </Link> */}</>
          ) : ("")}
        </div>
        <ToastContainer />        
      </div>
    );
  }
}
